import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { element, number, string } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';
import { Link, useLocation } from 'react-router';
import ListItemButton from '@mui/material/ListItemButton';

const listItemButtonSx = {
  borderRadius: '5px',
  // The divider is the label's top border. Button padding would sit outside
  // that line and leave the icon and label high in the gap.
  paddingTop: 0,
  paddingBottom: 0,
  '& + & .MuiListItemText-root': {
    borderTop: theme => `1px solid ${theme.palette.divider}`,
  },
  '&:hover .MuiListItemText-root': {
    borderColor: 'transparent !important',
  },
  '&:hover + & .MuiListItemText-root': {
    borderColor: 'transparent !important',
  },
  '&.Mui-selected .MuiListItemText-root': {
    borderColor: 'transparent !important',
  },
  '&.Mui-selected .MuiListItemText-primary': {
    fontWeight: 600,
  },
  '&.Mui-selected + & .MuiListItemText-root': {
    borderColor: 'transparent !important',
  },
};

const listItemTextSx = {
  // 50px content plus the 8px button padding this used to sit inside.
  minHeight: 66,
  display: 'flex',
  alignItems: 'center',
  p: 0,
  m: 0,
  borderBottom: 0,
};

const AdminItem = ({ icon, name }) => {
  const location = useLocation();
  const base = `/home/admin/${name}`;
  const selected = location.pathname === base || location.pathname.startsWith(`${base}/`);
  return (
    <ListItemButton sx={listItemButtonSx} component={Link} to={base} key={name} selected={selected}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText sx={listItemTextSx} primary={I18n.t(`SuperAdminMenu.${name}`)} />
    </ListItemButton>
  );
};

AdminItem.propTypes = {
  name: string.isRequired,
  icon: element.isRequired,
  index: number.isRequired,
};

export default AdminItem;
